import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

/**
 * Entries may be falsy: the render guards each one with `item && …`, and
 * callers rely on that to pass `[cond && <Icon />]` or `[null, <Icon />]`.
 *
 * @param {{
 *   left?: React.ReactNode[],
 *   right?: React.ReactNode[],
 *   className?: string,
 * }} props
 */
const Line = ({ left, right, className }) => (
  <div
    className={classNames(
      className,
      "cweb-line",
      "ui:flex-no-wrap ui:flex ui:flex-row"
    )}
  >
    <div className="ui:flex">
      {left?.map(
        (item) =>
          item && (
            <div
              key={item.key ?? item.props.id}
              className="ui:mr-3 ui:flex ui:items-center"
            >
              {item}
            </div>
          )
      )}
    </div>
    <div className="ui:grow" />
    <div className="ui:flex">
      {right?.map((item) => {
        return (
          item && (
            <div
              key={item.key ?? item.props.id}
              className="ui:ml-3 ui:first:ml-0"
            >
              {item}
            </div>
          )
        );
      })}
    </div>
  </div>
);

Line.propTypes = {
  left: PropTypes.array,
  right: PropTypes.array,
  className: PropTypes.string,
};

export default Line;
